export * from "./serialization";

// Re-export types for convenience
export type { PaymentItem as PaymentFormItem } from "./serialization";

// Import the local type with alias
import type { PaymentItem as PaymentFormItem } from "./serialization";

/**
 * Valida si los datos de payment son válidos
 */
export const validatePaymentData = (
  title: string,
  paymentItems: PaymentFormItem[],
): boolean => {
  // Validar título
  if (!title.trim()) return false;

  // Validar que haya al menos un item
  if (paymentItems.length === 0) return false;

  //Validar cada item
  return paymentItems.every((item) => {
    const hasValidConcept =
      item.conceptType === "input"
        ? item.concept.trim() !== ""
        : !!(
            item.conceptNode ||
            item.conceptField ||
            item.conceptOutput ||
            item.conceptGlobalType
          );

    const hasValidAmount =
      item.amountType === "input"
        ? item.amount.trim() !== "" &&
          !isNaN(parseFloat(item.amount)) &&
          parseFloat(item.amount) > 0
        : !!(
            item.amountNode ||
            item.amountField ||
            item.amountOutput ||
            item.amountGlobalType
          );

    return hasValidConcept && hasValidAmount;
  });
};

/**
 * Valida si se puede agregar un nuevo item de payment
 */
export const canAddNewPaymentItem = (
  paymentItems: PaymentFormItem[],
): boolean => {
  // Máximo 10 items
  if (paymentItems.length >= 10) return false;

  // Verificar que el último item esté completo
  if (paymentItems.length === 0) return true;

  const lastItem = paymentItems[paymentItems.length - 1];
  const lastItemComplete =
    (lastItem.conceptType === "input"
      ? lastItem.concept.trim() !== ""
      : !!(lastItem.conceptNode && lastItem.conceptNode.trim() !== "")) &&
    (lastItem.amountType === "input"
      ? lastItem.amount.trim() !== ""
      : !!(lastItem.amountNode && lastItem.amountNode.trim() !== ""));

  return lastItemComplete;
};
